import { ChevronRightIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";
import { FC } from "react";
import { Link } from "react-router-dom";
import { IDepartureCounts } from "../../interfaces/endpoints/IBoarding.types";
import Box from "../ui/Box";

// One departure on a phone: the whole card opens its passenger list. "Expected" is everyone who will ride
// this bus: those already scanned onto it, from any departure, plus those booked on it and not yet scanned.
const DepartureCard: FC<{ departure: IDepartureCounts; date: string }> = ({ departure, date }) => {
  const route = `${departure.from} → ${departure.to}`;
  const time = dayjs(departure.departure).format("HH:mm");
  const expected = departure.boarded + departure.toBoard;
  const share = expected ? (departure.boarded / expected) * 100 : 0;

  return (
    <Link
      to={`/scan/departures/${departure.tripId}/${date}`}
      state={{ crumbs: ["Kontrolli i biletave", "Udhëtarët", time] }}
      className="block rounded-lg"
    >
      <Box className="active:bg-gray-50">
        <div className="flex items-center justify-between gap-3">
          <span className="text-xl font-bold tabular-nums">{time}</span>
          <span className="flex items-center gap-1 text-sm text-neutral">
            Skanuar
            <strong className="text-base text-black tabular-nums">
              {departure.boarded} / {expected}
            </strong>
            <ChevronRightIcon aria-hidden className="h-4 w-4" />
          </span>
        </div>
        <p className="mt-1 break-words text-sm">{route}</p>
        <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-gray-200">
          <div className="h-full rounded-full bg-green-500" style={{ width: `${share}%` }} />
        </div>
        <div className="mt-2 flex justify-between gap-3 text-xs text-neutral">
          <span>{departure.toBoard} pa skanuar</span>
          {departure.boardedFromOtherDepartures > 0 && (
            <span>{departure.boardedFromOtherDepartures} nga nisje të tjera</span>
          )}
        </div>
      </Box>
    </Link>
  );
};

export default DepartureCard;
